var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalPayroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A4FEC",
    d: "M4.828 7.275h1v-2h-1v2zm17.862-2h-1v2h1v-2zm-17.862 0H2.93v2h1.897v-2zm-3.897 2v12h2v-12h-2zm2 14h21.655v-2H2.931v2zm23.655-2v-12h-2v12h2zm-2-14H22.69v2h1.896v-2zm2 2c0-1.104-.895-2-2-2v2h2zm-2 14c1.105 0 2-.895 2-2h-2v2zm-23.655-2c0 1.105.896 2 2 2v-2h-2zm2-14c-1.104 0-2 .896-2 2h2v-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A4FEC",
    fillRule: "evenodd",
    d: "M16.414 19.793v6.759h-4.828v-6.759h4.828z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A4FEC",
    fillRule: "evenodd",
    d: "M18.345 23.654v2.897h-8.69v-2.897h8.69zM11.564 15.992c-2.764.13-4.363.206-4.758-2.957-.469-3.75 2.622-7.558 6.503-7.72-.464 0-3.666-.004.055-.004h.2c3.721 0 .52.004.055.005 3.881.161 6.972 3.968 6.503 7.719-.395 3.163-1.994 3.088-4.758 2.957-.582-.028-1.215-.058-1.9-.06-.684.002-1.318.032-1.9.06z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A4FEC",
    d: "M10.207 4.827l-.552-2.759h2.207l1.1-.733c.337-.224.774-.224 1.11 0l1.1.733h2.207l-.551 2.759h-6.621z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.109 10.415c.094 0 .174.03.24.09.066.059.1.135.1.227 0 .097-.034.176-.1.236s-.146.089-.24.089h-.498c-.039.395-.188.72-.448.975-.254.249-.592.409-1.012.48.144.037.277.105.398.202.127.098.26.23.398.399l.871 1.096c.078.092.116.193.116.301 0 .125-.052.233-.157.325-.105.087-.224.13-.357.13-.171 0-.315-.073-.431-.22l-1.32-1.673c-.132-.173-.259-.295-.38-.366-.117-.07-.272-.105-.465-.105h-.697c-.337 0-.506-.136-.506-.407 0-.27.169-.406.506-.406h1.344c.636 0 1-.244 1.095-.731H10.96c-.094 0-.174-.03-.24-.09-.067-.06-.1-.138-.1-.235 0-.092.033-.168.1-.228.066-.06.146-.089.24-.089h2.58c-.127-.4-.484-.601-1.07-.601h-1.51c-.094 0-.174-.03-.24-.09-.067-.06-.1-.135-.1-.227 0-.098.033-.176.1-.236.066-.06.146-.09.24-.09h4.148c.094 0 .174.03.24.09s.1.138.1.236c0 .092-.034.168-.1.227-.066.06-.146.09-.24.09h-.847c.16.173.263.373.307.601h.54z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalPayroll);
export default __webpack_public_path__ + "static/media/digital-payroll.13735f75.svg";
export { ForwardRef as ReactComponent };